import { Stacked, Typography } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import AiSummaryImage from '@/images/screenshots/ai-summary.jpg';
import { OnboardingItemKey } from '@/types/userConfigs';
import { FirstTimeModal } from './FirstTimeModal';

type Props = { modalType: OnboardingItemKey };

export const FirstTimeModalAiSummary = ({ modalType }: Props) => {
  const { t } = useTranslation('modal');
  return (
    <FirstTimeModal
      modalType={modalType}
      id="first-time-ai-summary-modal"
      title={t('firstTimeModalAiSummary.title')}
      confirmLabel={t('firstTimeModalAiSummary.confirm')}
    >
      <Stacked direction="column" gap="medium">
        <div>
          <Typography variant="bodyRegular">{t('firstTimeModalAiSummary.content.0')}</Typography>
          <Typography variant="bodyRegular">{t('firstTimeModalAiSummary.content.1')}</Typography>
          <Typography variant="bodyRegular">{t('firstTimeModalAiSummary.content.2')}</Typography>
        </div>
        <img src={AiSummaryImage} width={648} height={266} alt={t('firstTimeModalAiSummary.imageAlt')} />
      </Stacked>
    </FirstTimeModal>
  );
};
